import Vue from "vue";
import Vuex from "vuex";

import { auth } from "./auth.module";
import { rnpl } from "./rnpl.module";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    rnpl
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js